module.exports = __webpack_public_path__ + "img/radio-perlis.c5ca4535.jpg";